import React from 'react';
import { ToolTipIcon } from '../../assets/icons/icons';
import { Box, Tooltip as MuiTooltip } from '@mui/material'; // Updated imports for Material-UI v5
import styled from '@emotion/styled';

const StyledTooltip = styled(MuiTooltip)`
  & .MuiTooltip-tooltip {
    padding: 16px;
    border: 2px solid ${(props) => props.theme.palette.common.accentBlue};
    border-radius: 5px;
    background-color: white;
    color: ${(props) => props.theme.palette.common.DTEPrimary};
    font-size: 16px;
  }

  & .MuiTooltip-arrow::before {
    border: 2px solid ${(props) => props.theme.palette.common.accentBlue};
    background-color: white;
  }
`;

export default function Tooltip({ content, children, withIcon }) {
  return (
    <StyledTooltip title={content} placement="right" arrow>
      <Box
        sx={{
          display: 'inline-flex',
          gap: '4px',
          alignItems: 'center',
          marginLeft: '8px',
          cursor: 'pointer',
        }}
      >
        {children}
        {(withIcon || !children?.length) && <ToolTipIcon />}
      </Box>
    </StyledTooltip>
  );
}
